import { render } from "./ShareholderCard.vue?vue&type=template&id=65d657cb&scoped=true&ts=true"
import script from "./ShareholderCard.vue?vue&type=script&lang=ts"
export * from "./ShareholderCard.vue?vue&type=script&lang=ts"

import "./ShareholderCard.vue?vue&type=style&index=0&id=65d657cb&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d657cb"]])

export default __exports__